import { useMapStore } from '../../lib/map/store';
import { useTranslation } from 'react-i18next';

// AddressDisplay component that uses Zustand store
export const AddressDisplay: React.FC = () => {
  const { t } = useTranslation();
  const { address, locationName, setIsAddressEditing } = useMapStore();
  
  if (!address) {
    return (
      <div className="mb-4 mx-4 p-3 bg-gray-100 rounded-lg opacity-70">
        <p className="text-sm text-gray-500 text-center">{t('components.map.dragMapInstruction')}</p>
      </div>
    );
  }

  // Truncate address after "Mueang Chiang Mai"
  const truncatedAddress = address.includes("Mueang Chiang Mai") 
    ? address.split("Mueang Chiang Mai")[0] + "Mueang Chiang Mai"
    : address;
    
  const handleEditClick = () => {
    // Set the state in the store
    setIsAddressEditing(true);
    
    // Get a reference to the parent component's handleProceedToDetails function
    // This is equivalent to clicking "Continue with This Location"
    const parentComponent = document.querySelector('button[data-action="proceed-to-details"]') as HTMLButtonElement;
    if (parentComponent) {
      parentComponent.click();
    }
  };

  return (
    <div className="mb-3 mx-4 p-2 bg-gray-100 rounded-lg">
      <div className="flex items-center justify-between mb-1">
        <div className="flex items-center">
          <div className="w-3 h-3 bg-red-600 rounded-full mr-2"></div>
          <p className="font-medium text-gray-800">{locationName}</p>
        </div>
        <button 
          onClick={handleEditClick}
          className="text-blue-500 hover:text-blue-700 focus:outline-none"
          aria-label={t('components.map.editAddress')}
        >
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 h-5">
            <path strokeLinecap="round" strokeLinejoin="round" d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L10.582 16.07a4.5 4.5 0 0 1-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 0 1 1.13-1.897l8.932-8.931Zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0 1 15.75 21H5.25A2.25 2.25 0 0 1 3 18.75V8.25A2.25 2.25 0 0 1 5.25 6H10" />
          </svg>
        </button>
      </div>
      <p className="text-xs text-gray-700 break-words whitespace-normal">{truncatedAddress}</p>
    </div>
  );
}; 